"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _VisuallyHidden = _interopRequireDefault(require("@match/react-component-library/components/VisuallyHidden"));

var _Text = _interopRequireDefault(require("@match/react-component-library/components/Text"));

var MenuItemLabel = function MenuItemLabel(_ref) {
  var hideLabel = _ref.hideLabel,
      label = _ref.label;

  if (hideLabel) {
    return _react.default.createElement(_VisuallyHidden.default, null, _react.default.createElement(_reactIntl.FormattedMessage, {
      id: label
    }));
  }

  return _react.default.createElement(_Text.default, {
    color: "light",
    bold: true,
    typography: "meta"
  }, _react.default.createElement(_reactIntl.FormattedMessage, {
    id: label
  }));
};

exports.MenuItemLabel = MenuItemLabel;